<template>
    <div v-if="this.repRec">
        <section v-if="this.result" class="Section">
            <div class="Container">
                <div class="Box9Wide Center">
                    <div class="Alert Good">
                        <div class="AlertTitle">Il tuo account è stato verificato correttamente</div>
                        <div class="AlertText">Adesso sarà possibile loggarsri nell'app</div>
                    </div>
                </div>
            </div>
        </section>
        <section v-else class="Section">
            <div class="Container">
                <div class="Box9Wide Center">
                    <div class="Alert Bad">
                        <div class="AlertTitle">Ops! Qualcosa è andato storto</div>
                        <div class="AlertText">C'è stato un problema nella verifica del tuo account</div>
                    </div>
                </div>
            </div>
        </section>
    </div>

</template>
<script>
import WebApiService from "@/services/webapi.service.js";

export default {
    name: 'RegistrationResult',
    data(){
        return {
            result: null
        }
    },
    mounted:function(){
        let token = this.$route.query.token;
        if(token != null && token){
            WebApiService.MyGet("AzioniUtente/ConfermaUtente", {token: token}).then(
                (data)=>{
                    console.log(data);
                    if(data?.StatusCode == 200){
                        this.result = true;
                    }else{
                        this.result = false;
                    }
                }
            );
        }
    },
    computed:{
        repRec: function(){
            return this.result != null;
        }
    }
    
}
</script>